import styled from 'styled-components/macro';

export const FilterBar = styled.div`
  position: sticky;
  top: 0px;
  width: 100%;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.white};
  z-index: 1;
`;

export const FilterContainer = styled.div`
  display: flex;
  height: 70px;
  padding: 0 50px 0 50px;
  align-items: center;
  background-color: ${({ theme }) => theme.coral};

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    width: 100%;
    height: calc(100vh - 48px);
    background-color: ${({ theme }) => theme.coral};
    flex-direction: column;
  }
`;

export const FilterButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 20px;
    border-style: none;
    background-color: transparent;
    font-family: ${({ theme }) => theme.primaryFontBold};
    font-size: ${({ theme }) => theme.h5}px;
    padding: 10px 20px;
    color: ${({ theme }) => theme.white};

    // &:first-of-type {
    //   background-color: ${({ theme }) => theme.coral};
    //   color: ${({ theme }) => theme.white};
    // }

    svg {
      margin-right: 15px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    flex-direction: column-reverse;
    justify-content: center;
    button {
      margin-left: 0;
      margin-bottom: 20px;
      width: 100%;
    }
  }
`;

export const ShowFilters = styled.div`
  width: 100%;
  height: 45px;
  background-color: ${({ theme }) => theme.coral};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.paragraphBig}px;
  text-transform: uppercase;
  cursor: pointer;
`;

export const FilterTitle = styled.div`
  width: 100%;
  position: relative;
  padding: 15px;
  text-align: center;
  font-family: ${({ theme }) => theme.primaryFontBold};
  font-size: ${({ theme }) => theme.paragraphBig}px;
  text-transform: uppercase;

  > div {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 10px;
    cursor: pointer;
  }
`;
